import { ChangeDetectorRef, Component, OnChanges, ViewEncapsulation } from '@angular/core';
import { CommmonUtil } from '../utils/common.util';
import { SMSservice } from '../../../../core/services/sms.service';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrl: './banner.component.css',
  encapsulation: ViewEncapsulation.None,
})
export class BannerComponent implements OnChanges {
  PatientPhoneNo:any;
  
  dashbaordCounts: any = []; 

  constructor(
    private smsService:SMSservice,
    private commmonUtil:CommmonUtil,
    private _cdr: ChangeDetectorRef){
    this.smsService.getDashboardgetPharmaInfo(); 
  }

  pharmacyInfo: any = {};
  
  ngOnChanges() {
    this.getPharmacyInformation();
  }
  ngOnInit() { 
    this.getPharmacyInformation();
  }
  
  async getPharmacyInformation() {
    this.pharmacyInfo = null;
    this._cdr.detectChanges();
    this.pharmacyInfo = JSON.parse(localStorage.getItem('PharmacyInfo') as string);
    this.PatientPhoneNo = this.commmonUtil.formatPhone(this.pharmacyInfo?.phone); 
  }
  handlePhoneClick(event: any){  
      this.copyPhoneNumber(); 
  }
  copyPhoneNumber() {
    const phoneLinkElement = document.getElementById('phoneLink');
    
    if (phoneLinkElement && phoneLinkElement.textContent) {   
        const PhoneNumber = phoneLinkElement.textContent.replace(/\D/g, '');
        const cleanedPhoneNumber = '+1'+PhoneNumber;
        navigator.clipboard.writeText(cleanedPhoneNumber)
            .then(() => this.showTooltip("Phone number copied!"))
            .catch(err => console.error('Failed to copy text:', err));
    } else {
        console.error('Phone link element not found or has no content.');
    }
  }
  showTooltip(message:any) {
      const tooltip = document.getElementById('tooltip');
      const phoneLinkElement = document.getElementById('phoneLink');
      
      if (tooltip && phoneLinkElement) {
          tooltip.textContent = message;
          tooltip.style.display = 'block'; 
          const rect = phoneLinkElement.getBoundingClientRect();
          const userAgent = navigator.userAgent || navigator.vendor;
          const isMobile = /iPhone|iPod|Android/i.test(userAgent);
          const isTablet = /iPad|Android/.test(userAgent) && !/Mobile/.test(userAgent); 
          let topOffset;
          let leftOffset;
          if(isMobile) {
              topOffset = rect.top + window.scrollY - tooltip.offsetHeight - 40;  
              leftOffset = rect.left + (rect.width / 2) - (tooltip.offsetWidth / 2) - 30;
          } else if(isTablet){
              topOffset = rect.top + window.scrollY - tooltip.offsetHeight - 5;  
              leftOffset = rect.left + (rect.width / 2) - (tooltip.offsetWidth / 2) - 10;
          } else {
              topOffset = rect.top + window.scrollY - tooltip.offsetHeight - 5;  
              leftOffset = rect.left + (rect.width / 2) - (tooltip.offsetWidth / 2) - 10;
          }
    
          tooltip.style.top = `${topOffset}px`;
          tooltip.style.left = `${leftOffset}px`;
          setTimeout(() => {
              tooltip.style.display = 'none';
          }, 2000);
      } else {
          console.error('Tooltip or phone link element not found.');
      }
  }
  
}
